import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Outlet } from 'react-router-dom';
export function PublicLayout() {
    return (_jsx("div", { className: "min-h-screen bg-white", children: _jsx(Outlet, {}) }));
}
